import { Outlet } from 'react-router-dom';
import TabelaGrupoCargo from './components/tabela';


export default function GrupoCargo() {

  return (
    <>
      <Outlet/>
      <TabelaGrupoCargo />
    </>
  )
}
